import { _post } from "../../Api";
import { toast } from "react-toastify";
import cloudStore from "../../store/CloudStore";
import { setMerchant } from "../../store/CloudActions";

export function updatePrinter(merchantId, printer, newData, updatedKey = true) {
  return updatePrinters(merchantId, [printer], [newData], null, updatedKey).then((printers) => {
    return Promise.resolve(printers[0]);
  });
}

export function updatePrinters(merchantId, printers, newData, oldValues, updatedKey = true) {
  let data = [];
  for (let i in printers) {
    if (printers[i]) {
      data.push({
        printerId: printers[i].id,
        ...newData[i],
      });
    } else {
      data.push({
        ...newData[i],
      });
    }
  }
  return _post("/nova/v2/printers/update", data)
    .then((res) => {
      let newMerchant = { ...cloudStore.merchant };
      // let newPrinters =
      res.data.forEach((printer) => {
        if (printer.merchant_id === newMerchant.id) {
          let index = newMerchant.printers.findIndex((printer2) => printer2.id === printer.id);
          if (index === -1) {
            newMerchant.printers.push(printer);
          } else {
            newMerchant.printers.splice(index, 1, printer);
          }
        }
      });

      setMerchant(newMerchant);
      toast.success("Saved", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return Promise.resolve(res.data);
    })
    .catch((e) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      console.log(e);
      return Promise.reject();
    });
}
